import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { Socket } from "socket.io-client";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IGetWarehouseTransferDTO from "../../../models/DTO/IGetWarehouseTransferDTO";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import { useNavigate, useParams} from "react-router-dom";
import IWarehouse_Transfer from "../../../models/IWarehouse_Transfer";
import IOnGetWarehouseTransferDTO from "../../../models/DTO/IOnGetWarehouseTransferDTO";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import OwTitle from "../../shared/OwTitle/OwTitle";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import styled from "styled-components";
import OwTable from "../../shared/OwTable/OwTable";
import IWarehouse_Transfer_Catalog_Item_Map from "../../../models/IWarehouse_Transfer_Catalog_Item_Map";
import IOwTableCols from "../../../models/IOwTableCols";
import OwButton from "../../shared/OwButton/OwButton";
import { TransferDetailAddItemSidebar } from "../../warehouse/TransferDetailAddItemSidebar/TransferDetailAddItemSidebar";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import IProcessWarehouseTransferItemDTO from "../../../models/DTO/IProcessWarehouseTransferItemDTO";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import {SocketContext} from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";

type Props = {};

interface IWarehouseTransferMapItemUI extends IWarehouse_Transfer_Catalog_Item_Map {
    editMode: boolean;
}

export const TransferDetail = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const history = useNavigate();

    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);
    // @ts-expect-error
    const { guid } = useParams();

    const editRow = (row: IWarehouseTransferMapItemUI) => {
        const _warehouseTransferItems = [...warehouseTransferItems];

        for (const warehouseTransferItem of _warehouseTransferItems) {
            if (warehouseTransferItem.guid === row.guid) {
                warehouseTransferItem.editMode = true;
            }
        }

        setWarehouseTransferItems(_warehouseTransferItems);
    };

    const deleteRow = (row: IWarehouseTransferMapItemUI) => {
        if (warehouseTransfer) {
            const payload: IProcessWarehouseTransferItemDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                warehouse_transfer_id: warehouseTransfer.id,
                catalog_item_id: row.catalog_item_id,
                deleteFlag: true,
            };

            socket.emit(EndpointsEnum.WarehouseProcessWarehouseTransferItem, payload);
        }
    };

    const renderActionsColFn = (row: IWarehouseTransferMapItemUI) => {
        if (warehouseTransfer?.received_at) {
            return null;
        } else {
            return (
                <div>
                    <OwIconButton iconClass={"fas fa-trash-alt"} iconColorClass={"text-danger me-2"} fn={() => deleteRow(row)} />
                    {/*<OwIconButton iconClass={'fas fa-pencil'} iconColorClass={'text-primary'} fn={() => editRow(row)}/>*/}
                </div>
            );
        }
    };

    const handleChange = (e: any, row: IWarehouseTransferMapItemUI) => {
        const value = e.target.value;
        const name = e.target.name;

        const _warehouseTransferItems = [...warehouseTransferItems];

        for (const warehouseTransferItem of _warehouseTransferItems) {
            if (warehouseTransferItem.guid === row.guid) {
                // @ts-expect-error
                warehouseTransferItem[name] = value;
            }
        }

        setWarehouseTransferItems(_warehouseTransferItems);
    };

    const saveQtyUpdate = (row: IWarehouseTransferMapItemUI) => {
        if (warehouseTransfer) {
            const payload: IProcessWarehouseTransferItemDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                warehouse_transfer_id: warehouseTransfer.id,
                catalog_item_id: row.catalog_item_id,
                sent_qty: row.sent_qty,
            };

            socket.emit(EndpointsEnum.WarehouseProcessWarehouseTransferItem, payload);

            const _warehouseTransferItems = [...warehouseTransferItems];

            // remove the rows edit flag
            for (const warehouseTransferItem of _warehouseTransferItems) {
                if (warehouseTransferItem.guid === row.guid) {
                    warehouseTransferItem.editMode = false;
                }
            }

            setWarehouseTransferItems(_warehouseTransferItems);
        }
    };

    const renderQtyColFn = (row: IWarehouseTransferMapItemUI) => {
        if (row.editMode) {
            return (
                <div>
                    <OwFnInput fn={(e: ChangeEvent<any>) => handleChange(e, row)} name={"sent_qty"} value={row.sent_qty || 0} />
                    <OwButton title={"save"} fn={() => saveQtyUpdate(row)} />
                </div>
            );
        } else {
            return row.sent_qty || 0;
        }
    };

    const getTableCols = (): IOwTableCols[] => {
        return [
            { title: "", valueProp: "", renderFn: renderActionsColFn, renderFnEmitsRow: true },
            { title: "name", valueProp: "Catalog_Item", valueSubProp: "name" },
            { title: "sku", valueProp: "Catalog_Item", valueSubProp: "sku" },
            { title: "qty", valueProp: "sent_qty", renderFn: renderQtyColFn, renderFnEmitsRow: true },
        ];
    };

    const [tableCols, setTableCols] = useState<IOwTableCols[]>([]);
    const [isDataFetching, setIsDataFetching] = useState<boolean>(true);
    const [isInitialData, setIsInitialData] = useState<boolean>(true);
    const [warehouseTransfer, setWarehouseTransfer] = useState<IWarehouse_Transfer | null>(null);
    const [warehouseTransferItems, setWarehouseTransferItems] = useState<IWarehouseTransferMapItemUI[]>([]);
    const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumbs[]>([
        { title: "inventory", url: "/inventory" },
        { title: "transfers", url: "/inventory/transfers" },
        { title: "transfer", url: `/inventory/transfer/${guid}` },
    ]);

    useEffect(() => {
        setTableCols(getTableCols());
    }, [warehouseTransferItems]);

    const getTransfer = () => {
        if (guid) {
            const payload: IGetWarehouseTransferDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                warehouseTransferGuid: guid,
            };

            socket.emit(EndpointsEnum.WarehouseGetTransfer, payload);

            setIsDataFetching(true);
        }
    };

    const onGetTransfer = (data: IOnGetWarehouseTransferDTO) => {
        setWarehouseTransfer(data.warehouseTransfer);

        const _warehouseTransferItems: IWarehouseTransferMapItemUI[] = (
            data.warehouseTransfer.Warehouse_Transfer_Catalog_Items_Maps || []
        ).map((mapItem) => {
            return {
                ...mapItem,
                editMode: false,
            };
        });

        setWarehouseTransferItems(_warehouseTransferItems);

        setIsDataFetching(false);
        setIsInitialData(false);
    };

    const processWarehouseTransferItem = () => {};

    const onProcessWarehouseTransferItem = () => {
        getTransfer();
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.WarehouseOnProcessWarehouseTransferItem, fn: onProcessWarehouseTransferItem },
        { endpoint: EndpointsEnum.WarehouseOnGetTransfer, fn: onGetTransfer },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getTransfer();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const closeSidebar = (refresh?: boolean) => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);

        if (refresh) {
            getTransfer();
        }
    };

    const openAddItemSidebar = () => {
        if (warehouseTransfer) {
            const sidebarComponent = (
                <TransferDetailAddItemSidebar
                    socket={socket}
                    notifyFn={uiContext.notifyFn}
                    closeFn={closeSidebar}
                    transfer={warehouseTransfer}
                />
            );

            uiContext.setSidebarComponent(sidebarComponent);
            uiContext.toggleSidebar(true);
        }
    };

    const viewTransferSlip = () => {
        if (warehouseTransfer) {
            history(`/inventory/transfers/${warehouseTransfer.guid}/slip`);
        }
    };

    return (
        <div className={"TransferDetail"}>
            <Breadcrumbs crumbs={breadcrumbs} />
            <div className="row">
                <div className="col-12">
                    <h1>Transfer Detail</h1>
                </div>
            </div>

            <div className={"d-flex align-items-center"}>
                <div className={"w-15r"}>
                    <OwTitle title={"origin"} tag={"h3"} />
                    {warehouseTransfer?.Origin_Warehouse?.name}
                    <AddressDisplay address={warehouseTransfer?.Origin_Warehouse?.Address} />
                </div>

                <CenterIcon>
                    <i className={"fal fa-truck-arrow-right"}></i>
                </CenterIcon>

                <div className={"w-15r"}>
                    <OwTitle title={"destination"} tag={"h3"} />
                    {warehouseTransfer?.Destination_Warehouse?.name}
                    <AddressDisplay address={warehouseTransfer?.Destination_Warehouse?.Address} />
                </div>
            </div>

            <div className={"mb-2 mt-4 d-flex justify-content-between"}>
                {!warehouseTransfer || warehouseTransfer?.received_at ? null : (
                    <div>
                        <OwButton title={"add_item"} fn={openAddItemSidebar} leftIconClass={"fas fa-plus"} className={"btn-warning"} />
                    </div>
                )}

                <div>
                    <div>
                        <OwButton
                            leftIconClass={"fas fa-print"}
                            title={"transfer_slip"}
                            fn={() => {
                                viewTransferSlip();
                            }}
                        />
                    </div>
                </div>
            </div>

            <div>
                <OwTable
                    columns={tableCols}
                    dataSet={warehouseTransferItems}
                    userModel={userModel}
                    supplierModel={supplierModel}
                    dataFetch={isDataFetching}
                    initialData={isInitialData}
                />
            </div>
        </div>
    );
};

const CenterIcon = styled.div`
    font-size: 2rem;
    width: 10rem;
`;
